<template>
  <div>
    <div
      class="bg-cover text-center"
      :style="{ backgroundImage: `url(https://summitproedu.imgix.net/redesign-assets/pages/course/course-test-hero.jpg?height=400px?blur=30)` }"
    >
      <t-container class="grid md:grid-cols-2 gap-10 py-20 items-center">
        <div class="mx-auto md:ml-auto">
          <course-thumbnail
            :course-test="true"
            :master-course-id="masterCourseId"
            :thumbnail="thumbnail"
            :preview-id="previewId"
            :podbean-id="selectedSession.podbeanId"
            :title="courseTitle"
          >
            <template #ratings>
              <div
                v-if="ratings.rating"
                class="hidden md:block md:pb-2 ml-2"
              >
                <div class="flex items-center">
                  <l-rating-stars
                    :rating="ratings.rating"
                    class="text-accent-light"
                  />
                  <p class="ml-2 text-white font-bold">
                    {{ ratings.rating }}/5
                  </p>
                </div>
                <p class="font-bold text-xs text-white">
                  {{ ratings.ratingCount }} Ratings<span v-if="ratings.reviewCount > 0"> - <a href="#reviews"><span class="text-white text-xs">{{ ratings.reviewCount }} Reviews</span></a></span>
                </p>
              </div>
            </template>
          </course-thumbnail>
          <div v-if="selectedFormat === 'PODCAST'">
            <podcast-social-icons />
          </div>
        </div>
        <div class="p-2 text-left">
          <div class="flex mb-2">
            <img
              :src="getIcon(selectedFormat)"
              :alt="format"
              class="h-8 mr-2"
            />
            <h6 class="text-white font-bold">
              {{ selectedSession.credits }}-Hour {{ getTitle(selectedFormat) }} Course
            </h6>
          </div>
          <h2
            class="text-white leading-normal"
            v-html="selectedSession.title"
          />
          <div
            v-for="instructor in selectedSession.instructors"
            :key="instructor.id"
            class="py-4"
          >
            <a
              v-if="instructor.url"
              :href="`https://summit-education.com/instructor/${instructor.url}`"
              target="_blank"
            >
              <h6 class="text-accent-light text-left font-bold">
                {{ instructor.name }}
              </h6>
            </a>
            <h6
              v-else
              class="text-accent-light text-left font-bold"
            >
              {{ instructor.name }}
            </h6>
          </div>
          <course-subscriber-payment-btn
            v-if="isValidSubscription"
            :is-valid-subscription="isValidSubscription"
            :selected-session="selectedSession"
            :loading="loading"
            :redirect-loading="redirectLoading"
            :selected-format="selectedFormat"
            :loading-item="loadingItem"
            :is-brochure="isBrochure"
            :btn-state="btnState"
            :is-included-in-subscription="isIncludedInSubscription"
            :is-two-hours-before-start-time="isTwoHoursBeforeStartTime"
            :check-item-selected="checkItemSelected"
            @add-to-subscription="addToSubscription()"
            @proceed-to-checkout="proceedToCheckout()"
            @add-item-to-cart="addItemToCart()"
            @go-to-live="goToLive()"
          />
          <t-button
            v-else
            class="mt-2"
            variant="ctaPrimary"
            @click="showPurchaseOptions()"
          >
            Purchase Options <t-icon
              name="chevron-right"
              class="text-white"
            />
          </t-button>
        </div>
      </t-container>
    </div>
    <div class="bg-background-primary md:flex w-full items-center text-center py-4">
      <button
        class="font-bold text-left text-white"
        @click="determineReturn()"
      >
        <span><t-icon
          class="text-summit-green text-2xl ml-10"
          name="chevron-left"
        /><t-icon
          class="text-summit-green text-2xl"
          name="chevron-left"
        /><t-icon
          class="text-summit-green text-2xl mr-5"
          name="chevron-left"
        /></span> Back to Search Results
      </button>
      <h6 class="font-bold my-3 text-white text-center md:ml-auto">
        Take This Course and Improve Your Patient Outcomes!
      </h6>

      <course-subscriber-payment-btn
        v-if="isValidSubscription"
        class="md:mr-auto md:ml-10"
        :is-valid-subscription="isValidSubscription"
        :selected-session="selectedSession"
        :loading="loading"
        :redirect-loading="redirectLoading"
        :selected-format="selectedFormat"
        :loading-item="loadingItem"
        :is-brochure="isBrochure"
        :btn-state="btnState"
        :is-included-in-subscription="isIncludedInSubscription"
        :is-two-hours-before-start-time="isTwoHoursBeforeStartTime"
        banner="true"
        :check-item-selected="checkItemSelected"
        @add-to-subscription="addToSubscription()"
        @proceed-to-checkout="proceedToCheckout()"
        @add-item-to-cart="addItemToCart()"
        @go-to-live="goToLive()"
      />
      <t-button
        v-else
        variant="ctaPrimary"
        class="md:mr-auto md:ml-10"
        @click="showPurchaseOptions()"
      >
        Purchase Options <t-icon
          name="chevron-right"
          class="text-white"
        />
      </t-button>
    </div>
  </div>
</template>

<script>
import { mapActions, } from 'pinia';
export default {

  name: 'TitleHero',
  props: {
    selectedSession: {
      type: Object,
      required: true,
    },
    ratings: {
      type: Object,
      required: true,
    },
    selectedFormat: {
      type: String,
      required: true,
    },
    masterCourseId: {
      type: String,
      required: true,
    },
    thumbnail: {
      type: String,
      required: true,
    },
    courseTitle: {
      type: String,
      required: true,
    },
    previewId: {
      type: String,
      default: null,
    },
    pathDetails: {
      type: Object,
      required: true,
      default: () => {},
    },
    isValidSubscription: {
      type: Boolean,
      default: false,

    },
    isIncludedInSubscription: {
      type: Boolean,
      default: false,

    },
    isTwoHoursBeforeStartTime: {
      type: Boolean,
      default: false,

    },
    loading: {
      type: Boolean,
      default: false,

    },
    redirectLoading: {
      type: Boolean,
      default: false,

    },
    loadingItem: {
      type: Boolean,
      default: false,

    },
    isBrochure: {
      type: Boolean,
      default: false,

    },
    btnState: {
      type: String,
      default: '',
    },
    checkItemSelected: {
      type: Boolean,
      default: false,

    },
  },
  emits: [
    'show-purchase', 'add-to-subscription', 'proceed-to-checkout', 'add-item-to-cart', 'go-to-live',
  ],

  setup() {
    const searchStore = useSearchStore();
    return { searchStore };
  },

  computed: {
    returnTo() {
      // route is undefined if coming from a short link (email or /b)
      if (typeof this.pathDetails.$route !== 'undefined' && typeof this.pathDetails.from !== 'undefined') {
        return this.pathDetails.$route.query.type === 'brochure' ? this.pathDetails.from.path : '/courses';
      }
      else {
        return '/courses';
      }
    },
  },
  methods: {
    determineReturn() {
      this.searchStore.setPage(this.page);
      this.$router.push(this.returnTo);
    },
    getIcon(format) {
      return {
        'LIVE': '//summitproedu.imgix.net/redesign-assets/icons/2025/in_person.svg',
        'LIVESTREAM': '//summitproedu.imgix.net/redesign-assets/icons/2025/live-stream.svg',
        'WEBINAR': '//summitproedu.imgix.net/redesign-assets/icons/2025/webinar.svg',
        'TEXT': '//summitproedu.imgix.net/redesign-assets/icons/2025/text.svg',
        'VIDEO': '//summitproedu.imgix.net/redesign-assets/icons/2025/online_video.svg',
        'PODCAST': '//summitproedu.imgix.net/redesign-assets/icons/2025/podcast.svg',
      }[format] || '//summitproedu.imgix.net/redesign-assets/icons/2025/in_person.svg';
    },
    getTitle(format) {
      return {
        LIVE: 'In-Person',
        LIVESTREAM: 'Livestream',
        WEBINAR: 'Webinar',
        TEXT: 'Text',
        VIDEO: 'Video',
        PODCAST: 'Podcast',
      }[format] || 'In-Person';
    },
    showPurchaseOptions() {
      this.$emit('show-purchase');
      document.querySelector('#subOptions').scrollIntoView({ behavior: 'smooth' });
    },
    addToSubscription(session) {
      this.$emit('add-to-subscription', session);
    },
    proceedToCheckout() {
      this.$emit('proceed-to-checkout');
    },
    addItemToCart() {
      this.$emit('add-item-to-cart');
    },
    goToLive() {
      this.$emit('go-to-live');
    },

  },
};
</script>
